<p>Build Date: {{versionInfo.date | date:'medium'}}</p>
<p>Version: {{versionInfo.version}}</p>
<p>Revision: {{versionInfo.revision}}</p>
<p>Branch: {{versionInfo.branch}}</p>
<p>Build Env: {{buildEnv}}</p>